import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Form, FormGroup } from 'reactstrap';
import { Field, reduxForm } from 'redux-form';
import { isRequired } from '../../../../utils/validators';
import FormItem from '../../../common/forms/FormItem';
import Loader from '../../../common/Loader';
import FormFooter from '../../../common/forms/FormFooter';
import SecurityProfileSelect from '../../../common/forms/select/SecurityProfileSelect';
import PaymentMethodSelect from '../../../common/forms/select/PaymentMethodSelect';

export const PaymentMethodForSecurityProfileForm = ({
  handleSubmit,
  loading,
}) => {
  if (loading) return <Loader />;

  return (
    <Form onSubmit={handleSubmit}>
      <FormGroup row>
        <FormItem label="Perfil de Seguridad" required>
          <Field
            name="securityProfileId"
            component={SecurityProfileSelect}
            validate={[isRequired]}
          />
        </FormItem>
      </FormGroup>
      <FormGroup row>
        <FormItem label="Metodo de Pago" required>
          <Field
            name="paymentMethodId"
            component={PaymentMethodSelect}
            validate={[isRequired]}
            allPaymentMethods
            transactionCodesNotIncluded={[]}
          />
        </FormItem>
      </FormGroup>
      <FormFooter />
    </Form>
  );
};

PaymentMethodForSecurityProfileForm.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  loading: PropTypes.bool.isRequired,
};

const mapStateToProps = ({ SecurityUnit }) => ({
  loading: !SecurityUnit.PaymentMethodForSecurityProfile.getIn([
    'current',
    'activity',
  ]).isEmpty(),
});

const formComponent = reduxForm({
  form: 'PaymentMethodForSecurityProfileForm',
})(PaymentMethodForSecurityProfileForm);

export default connect(mapStateToProps)(formComponent);
